import { getCurrentUserId } from '../../utils';


export const getAuthState = ({ auth }) => auth;

export const getUsers = ({ users }) => users.items;

export const getAuthorizedUser = ({ users }) => users.items[getCurrentUserId()] || {};



// WEBPACK FOOTER //
// ./src/redux/selectors/users.js